<template>
  <PosTicketView />
</template>

<script>
import PosTicketView from '@/views/admin/pos/PosTicket.vue';

export default {
  name: 'OperadorPosTicket',
  components: { PosTicketView },
};
</script>
